import axios from "axios";

export const generateAIHelper = async (
  content: string,
  helper_text: string
): Promise<{ text: string; success: boolean }> => {
  const openAIKEY = import.meta.env.VITE_APP_OPENAI_API_KEY;

  if (!openAIKEY) {
    console.error("OpenAI API key is missing");
    return { text: "OpenAI API key not found", success: false };
  }

  if (!content || content.trim() === "") {
    return { text: "No content to process", success: false };
  }

  try {
    const response = await axios.post(
      "https://api.openai.com/v1/chat/completions",
      {
        model: "gpt-3.5-turbo",
        messages: [
          {
            role: "system",
            content:
              "You are an expert assistant for coding, text, grammar, and general knowledge.",
          },
          { role: "user", content: `${helper_text}\n${content}` },
        ],
        max_tokens: 400,
        temperature: 0.7,
      },
      {
        headers: {
          Authorization: `Bearer ${openAIKEY}`,
          "Content-Type": "application/json",
        },
        // Uncomment if you call via backend and need cookies
        withCredentials: true
      }
    );

    const text = response.data?.choices?.[0]?.message?.content ?? "";

    return {
      text,
      success: !!text,
    };
  } catch (err: any) {
    console.error("OpenAI request failed:", err.response?.data || err.message);
    return {
      text: "Error generating AI text",
      success: false,
    };
  }
};